import { render } from "./job-listings.vue?vue&type=template&id=51a11ce7&scoped=true"
import script from "./job-listings.vue?vue&type=script&lang=js"
export * from "./job-listings.vue?vue&type=script&lang=js"

import "./job-listings.vue?vue&type=style&index=0&id=51a11ce7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a11ce7"]])

export default __exports__